import React from 'react';
import { Box, Button, Typography, Divider } from '@mui/material';
import { Phone, FileText } from 'lucide-react';

const AppFooter = ({
  handleFooterFormOpen = () => { console.log("this function opens footer form") },
  currentMessage,
  sideBarFlag
}) => {

  const handleDownload = (pdfName) => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/${pdfName}`;
    link.download = pdfName; // You can specify a custom file name here
    link.click();
  };

  const reportButtons = [
    { label: "Time OverRun Works ", color: "rgb(25, 118, 210)", fileName: "Time Over Run Works.pdf" },
    { label: "Time Over Run Works (Eng)", color: "rgb(46, 184, 92)", fileName: "time_over_run_works_eng.pdf" },
    { label: "A,B,C ", color: "#5B4CE2", fileName: "abc.pdf" }
  ];

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'white',
        padding: sideBarFlag ? '9px 24px 9px 24px' : '9px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 10,
        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.05)',
        borderTop: '1px solid #f0f0f0',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexGrow: 1,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '@media (max-width: 992px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px'
          }
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: '16px',
            fontWeight: 600,
            color: 'rgb(73, 80, 87)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            whiteSpace: 'nowrap'
          }}
        >
          <Box
            sx={{
              color: '#5B4CE2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(91, 76, 226, 0.1)',
              borderRadius: '50%',
              width: '40px',
              height: '40px'
            }}
          >
            <FileText size={20} />
          </Box>
          Generate Reports:
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            flexWrap: 'wrap',
            flexGrow: 1,
            transition: 'all 0.3s ease'
          }}
        >
          {reportButtons.map((report, index) => (
            <Button
              key={index}
              variant="outlined"
              onClick={() => handleDownload(report.fileName)}
              sx={{
                textTransform: 'none',
                borderColor: report.color,
                color: report.color,
                borderRadius: '8px',
                padding: sideBarFlag ? "6px 5px" : '6px 12px',
                fontSize: sideBarFlag ? "" : '16px',
                fontWeight: 500,
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: report.color,
                  color: 'white',
                  borderColor: report.color,
                  transform: 'translateY(-2px)',
                  boxShadow: '0px 4px 12px rgba(91, 76, 226, 0.25)'
                }
              }}
            >
              {report.label}
            </Button>
          ))}
        </Box>
      </Box>

      <Divider orientation="vertical" flexItem sx={{ mx: 3 }} />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '24px',
          flexShrink: 0,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '12px'
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            '@media (max-width: 768px)': {
              width: '100%',
              justifyContent: 'flex-end'
            }
          }}
        >
          <Box
            sx={{
              color: '#5B4CE2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(91, 76, 226, 0.1)',
              borderRadius: '50%',
              width: '40px',
              height: '40px'
            }}
          >
            <Phone size={20} />
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant="body2"
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                color: "#5B4CE2",
                lineHeight: 1.2
              }}
            >
              For Queries Call
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight: '600',
                fontSize: '16px',
                cursor: 'pointer',
                transition: 'color 0.3s, text-decoration 0.3s',
                color: "rgb(73, 80, 87)",
                '&:hover': {
                  color: '#5B4CE2',
                  textDecoration: 'underline'
                }
              }}
            >
              +91 9714105866
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontSize: '16px',
            color: "#5B4CE2",
            '@media (max-width: 768px)': {
              display: 'none'
            }
          }}
        >
          or
        </Typography>

        <Button
          onClick={handleFooterFormOpen}
          sx={{
            fontSize: '16px',
            fontWeight: "500",
            textTransform: 'none',
            padding: '8px 16px',
            borderRadius: '8px',
            // backgroundColor: '#f5f5f5',
            backgroundColor: "rgba(25, 118, 210, 0.1)",
            color: '#666',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#5B4CE2',
              color: 'white',
              boxShadow: '0px 4px 12px rgba(91, 76, 226, 0.25)',
              transform: 'translateY(-2px)'
            }
          }}
        >
          Register Grievance
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(AppFooter);






